import React from 'react';
import { getAssetIcon } from 'utils/icons';
import Icon from 'components/Icon';
import CardImage from 'components/CardImage';
import { jsx as _jsx } from "react/jsx-runtime";
function renderItemThumbnail(item) {
  var icon = getAssetIcon(item);
  return /*#__PURE__*/_jsx(CardImage, {
    src: item.pictureUrl && "".concat(item.pictureUrl, "/w_58,h_40"),
    width: 58,
    aspectRatio: 2 / 3,
    colorBlock: icon,
    fallbackContent: /*#__PURE__*/_jsx(Icon, {
      dimmed: true,
      name: icon
    })
  });
}
export default renderItemThumbnail;